import { Grid } from "@mui/material";
import { IAdditionalInformation } from "./IAdditionalInformation";
import CustomisedCardLine from "../../../../../components/card/cardLine";
import TextCard from "../../../../../components/card/TextCard";



export default function AdditionalInformationTab({
    residentialInformation, jobInformation, handleAttachedImage, showAttachedFileButton, tabIndex, additionalFields
}: IAdditionalInformation) {

    const handleAttachedImages = () => {
        handleAttachedImage(tabIndex);
    }

    const additionalInfo = additionalFields?.map(item => ({
        firstColumnText: item.title,
        secondColumnText: item.content
    }));
    return (
        <>
            <div style={{ height: "100%" }} className='container-height-without-drawer'>
                <Grid className='heightContainer' style={{ overflowY: "auto" }}>
                    {residentialInformation ?
                        <div
                            style={{
                                margin: 'auto',
                            }}
                        >
                            <div style={{ paddingBottom: '10px' }}>
                                <span
                                    className="font-normal text-sm primaryColorLight-900 anjomanRegular"
                                    style={{ fontSize: '14px' }}
                                >
                                    اطلاعات سکونتی
                                </span>
                            </div>
                            <CustomisedCardLine
                                itemList={residentialInformation}></CustomisedCardLine>
                        </div> : <></>}
                    {jobInformation ?
                        <div
                            style={{
                                margin: 'auto',
                                paddingTop: "20px"
                            }}
                        >
                            <div style={{ paddingBottom: '10px' }}>
                                <span
                                    className="font-normal text-sm primaryColorLight-900 anjomanRegular"
                                    style={{ fontSize: '14px' }}
                                >
                                    اطلاعات شغلی
                                </span>
                            </div>
                            <CustomisedCardLine
                                itemList={jobInformation}></CustomisedCardLine>
                        </div> : <></>}
                    {additionalFields &&
                        <div
                            style={{
                                margin: 'auto',
                                paddingTop: "20px"
                            }}
                        >
                            <div style={{ paddingBottom: '10px' }}>
                                <span
                                    className="font-normal text-sm primaryColorLight-900 anjomanRegular"
                                    style={{ fontSize: '14px' }}
                                >
                                    اطلاعات تکمیلی
                                </span>
                            </div>
                            <CustomisedCardLine itemList={[{ value: <TextCard description={additionalInfo} title="" /> }]} />

                        </div>}


                    <div
                        style={{
                            margin: 'auto',
                            marginTop: "40px",
                            paddingBottom: "40px"
                        }}
                    >
                        {showAttachedFileButton ?
                            <div style={{ paddingBottom: '20px' }}
                                onClick={handleAttachedImages}>
                                <span
                                    className=" text-sm primaryColorLight anjomanSemiBold"
                                    style={{ fontSize: '15px' }}
                                >
                                    مشاهده مستندات پرونده
                                </span>
                            </div> :
                            <></>}

                    </div>
                </Grid>
            </div>

        </>
    )
}